import React from 'react';
import logoWhite from '../assets/logo-white.png';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <img src={logoWhite} alt="유니원솔루션" />
              <span>유니원솔루션</span>
            </div>
            <p className="footer-tagline">공공과 기업의 지속 가능한 혁신을 지원하는 전문 컨설팅 기관</p>
          </div>
          <div className="footer-right">
            <div className="footer-links">
              <a href="#about">회사소개</a>
              <a href="#services">사업분야</a>
              <a href="#competencies">핵심역량</a>
              <a href="#projects">수행프로젝트</a>
              <a href="#contact">문의하기</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 유니원솔루션. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
